// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');

const setVisibleStep = (step) => (dispatch) => {
    dispatch({
        type: actionTypes.CARD_PIN_RESET_SET_VISIBLE_STEP,
        payload: {
            step
        }
    });
};

const validateStep = (step) => (dispatch) => {
    dispatch({
        type: actionTypes.CARD_PIN_RESET_VALIDATE_STEP,
        payload: {
            step
        }
    });
};

const cardPinResetRequestSuccess = () => ({
    type: actionTypes.CARD_PIN_RESET_SUCCESS,
});

const cardPinResetRequestFailure = (error) => ({
    type: actionTypes.CARD_PIN_RESET_ERROR,
    payload: {
        error
    }
});

const resetWizard = () => (dispatch) => {
    dispatch({
        type: actionTypes.CARD_PIN_RESET_RESET_WIZARD
    });
};

const handleFinish = (cardId) => (dispatch, getState) => {
    const card = getState().cards.getIn(['byId', cardId]).toJS();
    const {contract: {number: contractNumber}, number: pan, contract: {product}} = card;
    const callback = (dispatch, getState, dataToken) => {
        const params = {
            query: {
                contractNumber,
                dataToken,
                pan,
                product
            }
        }
        return APIPost({
            dispatch,
            endpoint: 'cardPinReset',
            params
        })
            .then((response) => dispatch(cardPinResetRequestSuccess(response)))
            .catch((response) => dispatch(cardPinResetRequestFailure(response.error)))
    }

    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
}

module.exports = {
    setVisibleStep,
    validateStep,
    resetWizard,
    handleFinish,
}
